import { useMemo } from "react";
import { bin } from "d3-array";
import { useTranslation } from "react-i18next";
import { trellisPalette } from "./palettes";
import { formatCurrency } from "../../../utils/formatNumber";
import FilterBar from "./FilterBar";
import { useAppSelector } from "../../../redux/hooks";
import { VStack } from "../../../../styled-system/jsx";
import { Chart } from "@highcharts/react";
import { css } from "../../../../styled-system/css";

const PricingView = ({
  shelfStatsTotalData,
  homeBrand,
  shelfData,
  selectedShelf,
  selectedSearchId,
  filterSearchId,
  selectedRollupType,
  filterRollupType,
  setSelectedDateRange,
  dateRange,
  isLoading,
}) => {
  const { t } = useTranslation(["merchandising"]);
  const marketPlace = useAppSelector((state) => state.marketPlace.marketPlace);

  const bins = useMemo(() => {
    const prices = shelfStatsTotalData.reduce(
      (a, d) =>
        a.concat(
          d.prices.map((price) => ({
            brand: d.brand,
            price,
          })),
        ),
      [],
    );
    return bin()
      .value((d) => d.price)
      .thresholds(9)(prices);
  }, [shelfStatsTotalData]);

  const options = {
    title: {
      text: "",
    },
    chart: {
      type: "column",
      style: {
        fontFamily: "Poppins",
        fontSize: "15px",
        cursor: "zoom-in",
      },
      height: "530px",
    },
    tooltip: {
      valueDecimals: 0,
    },
    xAxis: {
      categories: bins.map(
        (b) =>
          `${formatCurrency(b.x0, {
            marketPlace: marketPlace,
          })} - ${formatCurrency(b.x1, {
            marketPlace: marketPlace,
          })}`,
      ),
    },
    yAxis: [{ title: { text: "" } }],
    plotOptions: {
      column: {
        stacking: "normal",
        pointPadding: 0.05,
        groupPadding: 0.05,
      },
    },
    series: [
      {
        name: t(($) => $.merchandising["Home Brand"]),
        data: bins.map((b) => b.filter((d) => d?.brand?.toLowerCase() === homeBrand?.toLowerCase()).length),
        type: "column",
        color: trellisPalette[0],
      },
      {
        name: t(($) => $.merchandising["All Brands"]),
        data: bins.map((b) => b.filter((d) => d?.brand?.toLowerCase() !== homeBrand?.toLowerCase()).length),
        type: "column",
        color: trellisPalette[2],
      },
    ],
  };

  return (
    <VStack gap="medium" alignItems="stretch">
      <FilterBar
        shelfData={shelfData}
        filterSearchId={filterSearchId}
        selectedShelf={selectedShelf}
        selectedSearchId={selectedSearchId}
        selectedRollupType={selectedRollupType}
        filterRollupType={filterRollupType}
        setSelectedDateRange={setSelectedDateRange}
        dateRange={dateRange}
        isLoading={isLoading}
      />
      <h5 className={css({ margin: 0, textAlign: "center", fontWeight: "bold" })}>
        {t(($) => $.merchandising["Price Distribution"])}
      </h5>
      <Chart options={options} />
    </VStack>
  );
};

export default PricingView;
